var map = {
	"./24-alert-triangle-line-red.svg": [
		20284,
		284
	],
	"./24-alert-triangle-line.svg": [
		71257,
		1257
	],
	"./24-arrow-down.svg": [
		8309,
		8309
	],
	"./24-arrow-left.svg": [
		42580,
		2580
	],
	"./24-arrow-right.svg": [
		24256,
		4256
	],
	"./24-arrow-up.svg": [
		18560,
		8560
	],
	"./24-book.svg": [
		20192,
		192
	],
	"./24-cart-normal.svg": [
		58511,
		8511
	],
	"./24-cart-normal_2.svg": [
		20852,
		852
	],
	"./24-cart-normal_3.svg": [
		61536,
		3329
	],
	"./24-cart-notification.svg": [
		94820,
		7195
	],
	"./24-checkmark-green.svg": [
		14084,
		4084
	],
	"./24-checkmark.svg": [
		28707,
		8707
	],
	"./24-checkmark_2.svg": [
		88653,
		8653
	],
	"./24-chevron-down.svg": [
		75409,
		5409
	],
	"./24-chevron-left.svg": [
		72548,
		2548
	],
	"./24-chevron-right.svg": [
		19486,
		9486
	],
	"./24-chevron-up.svg": [
		29193,
		9193
	],
	"./24-clipboard.svg": [
		2343,
		2343
	],
	"./24-clock.svg": [
		69340,
		9340
	],
	"./24-close.svg": [
		56240,
		6240
	],
	"./24-comunicazioni.svg": [
		1864,
		1312
	],
	"./24-customize.svg": [
		30077,
		77
	],
	"./24-dati.svg": [
		96173,
		6173
	],
	"./24-documents.svg": [
		46363,
		6363
	],
	"./24-edit.svg": [
		63182,
		3182
	],
	"./24-gift.svg": [
		40348,
		348
	],
	"./24-grid-a-2-v-1.svg": [
		96404,
		6404
	],
	"./24-grid-a-3-v-1.svg": [
		31626,
		1626
	],
	"./24-indirizzi.svg": [
		3147,
		3147
	],
	"./24-larghezza.svg": [
		4219,
		4219
	],
	"./24-logo.svg": [
		50803,
		803
	],
	"./24-logo_2.svg": [
		83138,
		3138
	],
	"./24-minus-circle.svg": [
		49260,
		9260
	],
	"./24-offerte.svg": [
		90657,
		657
	],
	"./24-orders.svg": [
		84720,
		4720
	],
	"./24-pdf.svg": [
		63986,
		3986
	],
	"./24-plus-circle.svg": [
		48552,
		8552
	],
	"./24-plus.svg": [
		66034,
		6034
	],
	"./24-profile-2.svg": [
		19243,
		9243
	],
	"./24-remove.svg": [
		75914,
		5914
	],
	"./24-star.svg": [
		42665,
		2665
	],
	"./24-star_2.svg": [
		23410,
		3410
	],
	"./24-tag.svg": [
		10789,
		789
	],
	"./24-wishlist-line.svg": [
		87819,
		7819
	],
	"./24-zoom.svg": [
		7711,
		7711
	],
	"./32-pdf.svg": [
		75019,
		5019
	],
	"./32-xls.svg": [
		35791,
		5791
	],
	"./32-xml.svg": [
		1489,
		1489
	],
	"./40-alert.svg": [
		96721,
		6721
	],
	"./40-pdf.svg": [
		13030,
		3030
	],
	"./40-xls.svg": [
		28626,
		8626
	],
	"./40-xml.svg": [
		18084,
		8084
	],
	"./alert-triangle-line-red.svg": [
		31413,
		1413
	],
	"./arrow-down.svg": [
		4920,
		4920
	],
	"./arrow-left.svg": [
		71189,
		1189
	],
	"./arrow-right.svg": [
		24085,
		4085
	],
	"./arrow-up.svg": [
		62935,
		2935
	],
	"./bin.svg": [
		94454,
		4454
	],
	"./book.svg": [
		9906,
		9906
	],
	"./car.svg": [
		36072,
		6072
	],
	"./cart.svg": [
		61516,
		1516
	],
	"./checkmark-green.svg": [
		47516,
		7516
	],
	"./checkmark-white.svg": [
		16697,
		6697
	],
	"./checkmark.svg": [
		91701,
		1701
	],
	"./chevron-down.svg": [
		55865,
		5865
	],
	"./chevron-left.svg": [
		3677,
		3677
	],
	"./chevron-right.svg": [
		74827,
		4827
	],
	"./chevron-up.svg": [
		87775,
		7775
	],
	"./clipboard.svg": [
		62009,
		2009
	],
	"./clock.svg": [
		20513,
		513
	],
	"./close.svg": [
		59296,
		9296
	],
	"./comunicazioni.svg": [
		13024,
		3024
	],
	"./customize.svg": [
		93571,
		3571
	],
	"./dati.svg": [
		73546,
		3546
	],
	"./download.svg": [
		62059,
		2059
	],
	"./e-mail.svg": [
		71018,
		1018
	],
	"./edit.svg": [
		21395,
		1395
	],
	"./gift.svg": [
		23987,
		3987
	],
	"./icon-16-checkmark-circle-2.svg": [
		6875,
		6875
	],
	"./icon-16-goccia.svg": [
		23154,
		3154
	],
	"./icon-24-filter.svg": [
		19501,
		6523
	],
	"./icon-24-search.svg": [
		17017,
		7017
	],
	"./icon-32-custom.svg": [
		12319,
		2319
	],
	"./icon-32-customer-service.svg": [
		260,
		260
	],
	"./icon-32-imballi.svg": [
		92940,
		2940
	],
	"./icon-32-qualit.svg": [
		8699,
		8699
	],
	"./icon-32-timer.svg": [
		71307,
		1307
	],
	"./illustration-posizione-1.svg": [
		10014,
		14
	],
	"./illustration-posizione-2.svg": [
		90865,
		865
	],
	"./illustration-posizione-3.svg": [
		42768,
		2768
	],
	"./indirizzi.svg": [
		25853,
		5853
	],
	"./info.svg": [
		72814,
		2814
	],
	"./logo-sipec.svg": [
		63083,
		3083
	],
	"./logo.svg": [
		90959,
		8228
	],
	"./minus-circle.svg": [
		60035,
		35
	],
	"./minus.svg": [
		97196,
		7196
	],
	"./offerte.svg": [
		77018,
		7018
	],
	"./orders.svg": [
		12171,
		7986
	],
	"./pdf.svg": [
		50619,
		619
	],
	"./pin.svg": [
		90242,
		242
	],
	"./plus-circle.svg": [
		2156,
		2156
	],
	"./plus.svg": [
		80780,
		780
	],
	"./plus_2.svg": [
		63262,
		3262
	],
	"./remove.svg": [
		96125,
		6125
	],
	"./replace.svg": [
		63540,
		3540
	],
	"./star.svg": [
		22674,
		2674
	],
	"./tag.svg": [
		13526,
		3526
	],
	"./wishlist-line.svg": [
		45252,
		5776
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7257;
module.exports = webpackAsyncContext;